import { Checkbox, FormControlLabel } from '@mui/material'
import React from 'react'

import { createComponentWrapperWithRef, styled, uiTokens } from '../../theme'
import { OptionItem } from '../../utils'

const StyledMuiFormControlLabel = styled(FormControlLabel)`
  margin-left: 5px;
  max-width: fit-content;
`
const StyledNovaFormControlLabel = styled(FormControlLabel)`
  & .MuiFormControlLabel-label {
    font-family: ${uiTokens.font.fontFamily.default};
  }
  max-width: fit-content;
`
const StyledFormControlLabel = createComponentWrapperWithRef(
  {
    mui: StyledMuiFormControlLabel,
    nova: StyledNovaFormControlLabel,
  },
  'StyledFormControlLabel',
)

const StyledCheckbox = createComponentWrapperWithRef(
  {
    mui: Checkbox,
    nova: Checkbox,
    novaProps: {
      sx: {
        '&.MuiCheckbox-root': {
          color: uiTokens.uiControl.contained.enabled,
        },
      },
    },
  },
  'StyledCheckbox',
)

interface Props {
  disabled: boolean
  label: string
  value: OptionItem
  options: OptionItem[]
  onChange: (value: string) => void
}

export function CheckboxSingle(props: Props) {
  const checked = () => {
    return props.value && props.options.some((opt) => opt.value === props.value.value)
  }

  // eslint-disable-next-line @typescript-eslint/no-shadow
  const handleChange = (checked: boolean) => {
    const opt = props.options.length > 1 ? props.options[1] : props.options[0]
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const v: any = checked ? opt : null
    props.onChange(v ? v.value : null)
  }

  return (
    <StyledFormControlLabel
      control={
        <StyledCheckbox
          data-test-id="checkbox-group-item"
          checked={checked()}
          // eslint-disable-next-line @typescript-eslint/no-shadow
          onChange={(_, checked) => handleChange(checked)}
        />
      }
      label={props.label}
      disabled={props.disabled}
    />
  )
}
